import * as React from 'react';
import { makeFileRequest, addScriptsToDocument, getFooterKey } from './helpers.js';
import { REACT_COMP_VERSION } from '../constants.js';

var _a;
var footerContainer = typeof document !== "undefined"
    ? document.getElementById("bookendsFooter")
    : null;
var footerAddedOnEdge = footerContainer && ((_a = footerContainer === null || footerContainer === void 0 ? void 0 : footerContainer.children) === null || _a === void 0 ? void 0 : _a.length) > 0;
var footer = footerAddedOnEdge && footerContainer ? footerContainer.innerHTML : "";
var footerScripts;
var isSpaEntry = true;
var Footer = function (props) {
    var _a = React.useState(false), isFooterAdded = _a[0], setIsFooterAdded = _a[1];
    var _b = React.useState(footer), footerHtml = _b[0], setFooterHtml = _b[1];
    var _c = React.useState(footerScripts), bookendsScripts = _c[0], setBookendsScripts = _c[1];
    var variation = "default";
    if (typeof window !== "undefined") {
        window.bookends.trackingConfiguration = props.trackingConfiguration;
        window.bookends.deepLink = props.deepLink;
        if (window.bookendsFooterVariation) {
            variation = window.bookendsFooterVariation;
        }
    }
    React.useEffect(function () {
        if ((footerAddedOnEdge || isFooterAdded) && footerContainer) {
            var scripts = Array.from(footerContainer === null || footerContainer === void 0 ? void 0 : footerContainer.querySelectorAll("script")).map(function (script) {
                return {
                    src: script.src,
                    innerHTML: script.innerHTML.trim()
                };
            });
            footerAddedOnEdge = false;
            footerScripts = scripts;
            if (!isFooterAdded) {
                setIsFooterAdded(true);
            }
        }
    }, []);
    React.useEffect(function () {
        if ((!footer && (footerContainer === null || footerContainer === void 0 ? void 0 : footerContainer.children.length) === 0) || (!footerContainer && isSpaEntry)) {
            var bundleScriptHtmlPromise = makeFileRequest(props.stagingContent, "/html/statics/dep-share/".concat(REACT_COMP_VERSION, "_bundle-script.html"));
            var footerHtmlPromise = makeFileRequest(props.stagingContent, "/esi/".concat(REACT_COMP_VERSION, "/").concat(props.tenant, "/").concat(props.locale.toLowerCase(), "/footer/").concat(props.type, "/dep-share/").concat(variation, "-fullcomponent.html"));
            var parser_1 = new DOMParser();
            Promise.all([bundleScriptHtmlPromise, footerHtmlPromise]).then(function (htmlResponse) {
                var tmpElement = parser_1.parseFromString(htmlResponse[1], "text/html");
                var scriptElements = Array.from(tmpElement.querySelectorAll("script"));
                var scripts = [{
                        src: undefined,
                        innerHTML: htmlResponse[0].replace("<script>", "").replace("</script>", "").trim()
                    }];
                scriptElements.forEach(function (scriptElement) {
                    scripts.push({
                        src: scriptElement.src,
                        innerHTML: scriptElement.innerHTML.trim()
                    });
                    tmpElement.body.removeChild(scriptElement);
                });
                setFooterHtml(tmpElement.head.outerHTML + tmpElement.body.outerHTML);
                setBookendsScripts(scripts);
                isSpaEntry = false;
                footer = tmpElement.head.outerHTML + tmpElement.body.outerHTML;
                footerScripts = scripts;
            });
        }
    }, []);
    React.useEffect(function () {
        var _a;
        var footerElement = document.getElementById("".concat(props.type, "_footer"));
        if (((!footerAddedOnEdge && !isFooterAdded) || !isSpaEntry)
            && bookendsScripts
            && ((_a = footerElement === null || footerElement === void 0 ? void 0 : footerElement.dataset) === null || _a === void 0 ? void 0 : _a.hydrated) !== "true") {
            if (!window.bundleInterval
                || !window["".concat(props.type, "_footer_componentWrapperInterval")]) {
                var scriptsToAdd = bookendsScripts;
                if (window.bundleInterval) { //Prevent double loading bundleInterval
                    scriptsToAdd = bookendsScripts.filter(function (script) { return !script.innerHTML.startsWith("var bundleInterval"); });
                }
                addScriptsToDocument(scriptsToAdd);
            }
            if (window
                && window.ComponentWrapper
                && window.ComponentWrapper["show_".concat(props.type, "_footer")]
                && window["".concat(props.type, "_footer_props")]) {
                window.ComponentWrapper["show_".concat(props.type, "_footer")](window["".concat(props.type, "_footer_props")]);
            }
        }
    });
    return (React.createElement("div", { id: "bookendsFooter", "data-footerkey": getFooterKey(props.tenant, props.locale, props.type), dangerouslySetInnerHTML: { __html: footerHtml } }));
};

export { Footer };
//# sourceMappingURL=Footer.js.map
